import { render } from "./PageShell.vue?vue&type=template&id=eb6629e4&scoped=true"
import script from "./PageShell.vue?vue&type=script&lang=js"
export * from "./PageShell.vue?vue&type=script&lang=js"

import "./PageShell.vue?vue&type=style&index=0&id=eb6629e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6629e4"]])

export default __exports__